/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ApiRoleData model module.
 * @module model/ApiRoleData
 * @version 1.0
 */
class ApiRoleData {
    /**
     * Constructs a new <code>ApiRoleData</code>.
     * @alias module:model/ApiRoleData
     */
    constructor() { 
        
        ApiRoleData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ApiRoleData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ApiRoleData} obj Optional instance to populate.
     * @return {module:model/ApiRoleData} The populated <code>ApiRoleData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ApiRoleData();

            if (data.hasOwnProperty('apiUrl')) {
                obj['apiUrl'] = ApiClient.convertToType(data['apiUrl'], 'String');
            }
            if (data.hasOwnProperty('gnbNo')) {
                obj['gnbNo'] = ApiClient.convertToType(data['gnbNo'], 'Number');
            }
            if (data.hasOwnProperty('lnbNo')) {
                obj['lnbNo'] = ApiClient.convertToType(data['lnbNo'], 'Number');
            }
            if (data.hasOwnProperty('subNo')) {
                obj['subNo'] = ApiClient.convertToType(data['subNo'], 'Number');
            }
            if (data.hasOwnProperty('dontReadonly')) {
                obj['dontReadonly'] = ApiClient.convertToType(data['dontReadonly'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ApiRoleData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ApiRoleData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['apiUrl'] && !(typeof data['apiUrl'] === 'string' || data['apiUrl'] instanceof String)) {
            throw new Error("Expected the field `apiUrl` to be a primitive type in the JSON string but got " + data['apiUrl']);
        }

        return true;
    }


}



/**
 * @member {String} apiUrl
 */
ApiRoleData.prototype['apiUrl'] = undefined;

/**
 * @member {Number} gnbNo
 */
ApiRoleData.prototype['gnbNo'] = undefined;

/**
 * @member {Number} lnbNo
 */
ApiRoleData.prototype['lnbNo'] = undefined;

/**
 * @member {Number} subNo
 */
ApiRoleData.prototype['subNo'] = undefined;

/**
 * @member {Boolean} dontReadonly
 */
ApiRoleData.prototype['dontReadonly'] = undefined;






export default ApiRoleData;

